import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Booking', href: '#booking' },
  { label: 'Payment', href: '#payment' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-black/95 backdrop-blur-sm border-b border-gray-800'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }}
          className="flex flex-col cursor-pointer"
        >
          <span className="font-display silver-gradient-text text-xl font-semibold tracking-[0.2em] uppercase leading-tight">
            Luxury Prom
          </span>
          <span className="text-gray-400 text-[9px] tracking-[0.35em] uppercase font-light">
            Chauffeur Experience
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="text-gray-300 hover:text-white text-xs tracking-[0.15em] uppercase font-medium transition-colors duration-200 cursor-pointer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Phone */}
        <a
          href="tel:2677731129"
          className="hidden md:flex items-center gap-2 silver-border rounded-full px-4 py-2 text-gray-300 hover:text-white hover:border-gray-400 transition-all duration-200 cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-line text-sm"></i>
          </div>
          <span className="text-xs tracking-wide whitespace-nowrap">(267) 773-1129</span>
        </a>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-gray-300 hover:text-white cursor-pointer"
        >
          <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-black/98 border-t border-gray-800 px-6 py-4">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="text-gray-300 hover:text-white text-sm tracking-[0.1em] uppercase font-medium transition-colors duration-200 cursor-pointer block py-2"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="tel:2677731129"
                className="text-gray-400 text-sm flex items-center gap-2 cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                (267) 773-1129
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
